import request from '@/utils/request'
export function uploadFile(formData) {
  return request({
    url:'/api/filemanage/file-upload',
    method:'POST',
	data:formData
  })
}
export function getImageMediaId() {
  return request({
    url:'/api/filemanage/image-mediaid',
    method:'get',
  })
}
export function getFileInfoByMediaId(data){
	return request({
	  url:'/api/filemanage/get-file-info-by-mediaId?mediaId='+data,
	  method:'get',
	})
}
export function uploadFileTest(formData) {
  return request({
    url:'/api/Temporary/analysis-excel',
    method:'POST',
	data:formData
  })
}